import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Tooltip } from 'tdesign-react';
import { useLocation } from 'react-router-dom';
import { getCurrentCluster } from '../CulsterAddon';

// 备集群标签
function BackupClusterTag({ rootPath, currentCluster }) {
  const { pathname } = useLocation();
  // 是否是备集群
  const isRecoveryCluster = !!currentCluster?.isDisasterRecoveryCluster;
  const isDashboard = pathname.indexOf('/cluster/dashboard') > -1;

  if (rootPath === '/cluster' && isRecoveryCluster && !isDashboard) {
    return (
      <Root>
        <Tooltip
          placement='left'
          content='备集群通常用于提供高可用性、容错性和数据备份等功能，以应对故障和灾难的场景。通常建议该集群单一职责，不与业务场景混用。'
        >
          备集群
        </Tooltip>
      </Root>
    );
  }
  return null;
}

export default connect((state) => ({
  currentCluster: getCurrentCluster(state.cluster.allList),
}))(BackupClusterTag);

const Root = styled.div`
  position: absolute;
  right: 36px;
  top: 16px;
  height: 24px;
  background: rgb(62, 96, 246);
  border-radius: 12px;
  border-bottom-left-radius: 0;

  color: rgb(255, 255, 255);
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;

  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  padding: 0 12px;
`;
